var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehiclesList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_11328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.125 3.125H13.125",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 5.625H11.25",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 9.375H13.125",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 11.875H11.25",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 3.125C1.875 2.95924 1.94085 2.80027 2.05806 2.68306C2.17527 2.56585 2.33424 2.5 2.5 2.5H5C5.16576 2.5 5.32473 2.56585 5.44194 2.68306C5.55915 2.80027 5.625 2.95924 5.625 3.125V5.625C5.625 5.79076 5.55915 5.94973 5.44194 6.06694C5.32473 6.18415 5.16576 6.25 5 6.25H2.5C2.33424 6.25 2.17527 6.18415 2.05806 6.06694C1.94085 5.94973 1.875 5.79076 1.875 5.625V3.125Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 9.375C1.875 9.20924 1.94085 9.05027 2.05806 8.93306C2.17527 8.81585 2.33424 8.75 2.5 8.75H5C5.16576 8.75 5.32473 8.81585 5.44194 8.93306C5.55915 9.05027 5.625 9.20924 5.625 9.375V11.875C5.625 12.0408 5.55915 12.1997 5.44194 12.3169C5.32473 12.4342 5.16576 12.5 5 12.5H2.5C2.33424 12.5 2.17527 12.4342 2.05806 12.3169C1.94085 12.1997 1.875 12.0408 1.875 11.875V9.375Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_11328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehiclesList);
export default __webpack_public_path__ + "static/media/vehiclesList.e0466231fbe78226233fae8536ef8817.svg";
export { ForwardRef as ReactComponent };